<script setup>
import {computed, inject, ref, toRaw,} from "vue";
import {useSearchStore} from "../store/useSearchStore";

const $bus = inject('$bus');
const store = useSearchStore();

const props = defineProps({
    page: {
        type: Boolean,
        default: false,
    },
    data: {
        type: Object,
        default: null,
    },
    allResults: {
        type: Array,
        default: null,
    },
    index: {
        type: Number,
        default: null,
    },
    searchQuery: {
        type: String,
        default: null,
    },
    selected: {
        type: Boolean,
        default: false,
    },
    noSearch: Boolean,
    searchUrl: {
        type: String,
        default: null
    }
});

const currentActiveIndex = ref(-1);

const datasheetStatus = () => {
    return Object.prototype.hasOwnProperty.call(props.data, 'datasheetStatus')
        ? props.data.datasheetStatus
        : null;
};

const datasheetUrl = () => {
    if (this.datasheetStatus === 'RESTRICTED') {
        return `/products/request-datasheet?product=${this.data.title}`;
    }

    return props.data.hasOwnProperty('datasheetUrl') && props.data.datasheetUrl.length > 0
        ? props.data.datasheetUrl
        : null;
};

const handleClickEvent = (event) => {
    event.preventDefault();
    if (props.data.targetUrl) {
        if (props.data._target && props.data._target === '_blank') {
            window.open(props.data.targetUrl, props.data._target); // open in new tab
        } else {
            window.location.href = props.data.targetUrl;
        }
    } else {
        if (props.data.title) {
            window.location.href = props.searchUrl + props.data.title
        }
    }
};

const quickSearchResultRef = (el) => {
    if (el && !toRaw(store.quickResults).includes(el)) {
        store.quickResults.push(el);

    }
};

const handleFocus = (index) => {

    let arrayIndex = index - 1;

    if (store.quickResults[arrayIndex] !== undefined) {
        store.quickResults[arrayIndex].focus();
    }
};


const activeIndexFunction = (index) => {
    currentActiveIndex.value = index;
    handleFocus(index);
};

const handleUpEventResult = (index) => {
    if (index > -1) {
        activeIndexFunction(index - 1);
    } else {
        activeIndexFunction(index);
    }
};

const handleDownEventResult = (index) => {
    if (index >= store.maxCustomResultIndex) {
        activeIndexFunction(index);
    } else {
        activeIndexFunction(index + 1);
    }
};

const index = computed(() => props.index);
const customCounter = store.incrementCustomResultIndex();

</script>

<template>

    <a :href="(datasheetUrl ?  datasheetUrl : ((props.data.targetUrl) ? props.data.targetUrl : '#'))"
       :id="`search-result-${customCounter}`"
       v-bind="{ 'data-url': (datasheetUrl ?  datasheetUrl : ((props.data.targetUrl) ? props.data.targetUrl : '#'))}"
       :class="[{'is-active' : props.selected}, 'search-result', `search-result-${customCounter}`]"
       :tabindex="customCounter"
       :key="customCounter"
       @click="handleClickEvent"
       :ref="quickSearchResultRef"
       v-on:keyup.up.stop="handleUpEventResult(customCounter)"
       v-on:keyup.down.stop="handleDownEventResult(customCounter)"
    >
        <h3 class="title is-4" v-html="props.data.title"></h3>
        <div class="choose">
            <span v-html="$t('search.choose')"></span>
            <svg width="16" height="16">
                <use xlink:href="#search-icon-download"></use>
            </svg>
        </div>
    </a>
</template>
